import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const StrikeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Strike",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M8.54 13.59h7.39c-3.88-.68-4.1-2.12-4.23-3.2 0-.12-.31-3 3.25-3.61a6.33 6.33 0 0 1 5.31 1.14h-.01c.36.33.84.53 1.38.53a2.01 2.01 0 0 0 1.38-3.47 10.33 10.33 0 0 0-6.59-2.37c-.78 0-1.53.08-2.26.25h.07c-5.34.99-6.81 5.32-6.49 7.99.1 1.02.39 1.95.83 2.78l-.02-.04ZM28 15.32H4a2 2 0 1 0 0 4h16.22a3.12 3.12 0 0 1 .71 2.52v-.02c-.13 1.71-1.46 2.93-3.74 3.44-2.94.65-5.43-1.75-5.45-1.76-.36-.37-.87-.6-1.43-.6-1.1 0-2 .9-2 2 0 .55.22 1.04.58 1.41a11.04 11.04 0 0 0 7.22 3.07h.02c.68 0 1.35-.08 1.99-.23h-.06c4-.88 6.6-3.52 6.85-6.99 0-.15.01-.32.01-.5 0-.82-.12-1.61-.34-2.35v.06h3.41c1.1 0 2-.9 2-2s-.9-2-2-2v-.05Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M15.57 30.97c-4.29 0-7.7-2.69-7.84-2.81-.49-.4-.57-1.11-.18-1.61.39-.49 1.11-.57 1.61-.18.03.02 2.94 2.31 6.41 2.31s5.99-2.68 5.99-5.98c0-.48-.07-.94-.2-1.39-.18-.6.16-1.24.77-1.42s1.24.16 1.42.77q.3.99.3 2.04c0 4.56-3.71 8.27-8.27 8.27ZM9.89 12.99c-.41 0-.81-.22-1.01-.61-.49-.93-.73-1.97-.73-3.09 0-4.1 3.33-7.43 7.43-7.43 3.75 0 6.75 1.8 6.88 1.88.54.33.71 1.03.38 1.57s-1.03.71-1.57.38-2.6-1.55-5.69-1.55c-2.84 0-5.14 2.31-5.14 5.14 0 .74.16 1.43.47 2.03a1.14 1.14 0 0 1-1.01 1.67ZM28.14 17.56H3a1.14 1.14 0 1 1 0-2.28h25.14a1.14 1.14 0 1 1 0 2.28"
      })
    })
  }));
};
StrikeIcon.displayName = 'StrikeIcon';